<template>
  <div class="container-fluid mt-3">

    <!-- Tabs PTR / RTR -->
    <div class="d-flex align-items-center gap-3 mb-3 border-bottom pb-2">
      <button type="button" class="tab-modo"
        :class="tabActual === 'ptr' ? 'tab-modo-active-edit' : 'tab-modo-inactive'"
        @click="tabActual = 'ptr'">
        <span class="material-symbols-outlined" style="font-size:16px;vertical-align:middle">assignment</span>
        Pedido de Terapias (PTR)
      </button>
      <button type="button" class="tab-modo"
        :class="tabActual === 'rtr' ? 'tab-modo-active-view' : 'tab-modo-inactive'"
        :disabled="!pedido"
        @click="tabActual = 'rtr'">
        <span class="material-symbols-outlined" style="font-size:16px;vertical-align:middle">fact_check</span>
        Registro de Sesiones (RTR)
      </button>
      <span v-if="!pedido" class="badge bg-secondary ms-1" style="font-size:10px">
        Primero registre el pedido PTR
      </span>
    </div>

    <!--
         TAB PTR — Pedido de Terapias
     -->
    <div v-if="tabActual === 'ptr'">

      <!-- Datos del pedido -->
      <div class="card mb-3">
        <div class="card-header py-2 d-flex justify-content-between align-items-center">
          <small class="fw-bold">Datos del Pedido</small>
          <span v-if="pedido" class="badge bg-success" style="font-size:10px">
            Pedido registrado
          </span>
        </div>
        <div class="card-body py-2">
          <div class="row g-2">
            <div class="col-md-4">
              <label class="form-label" style="font-size:12px">Fecha del Pedido</label>
              <input type="date" class="form-control form-control-sm"
                v-model="formPedido.fechaPedido"
                :disabled="!editable"/>
            </div>
            <div class="col-md-4">
              <label class="form-label" style="font-size:12px">Hora</label>
              <input type="time" class="form-control form-control-sm"
                v-model="formPedido.horaPedido"
                :disabled="!editable"/>
            </div>
            <div class="col-md-4">
              <label class="form-label" style="font-size:12px">Médico Solicitante</label>
              <select class="form-select form-select-sm"
                v-model="formPedido.idMedico"
                :disabled="!editable">
                <option value="">-- Seleccione --</option>
                <option v-for="m in medicos" :key="m.idMedico" :value="m.idMedico">
                  {{ m.nombreMedico }}
                </option>
              </select>
            </div>
            <div class="col-12">
              <label class="form-label" style="font-size:12px">
                Observaciones (periodicidad y tiempo)
              </label>
              <textarea class="form-control form-control-sm"
                v-model="formPedido.observaciones"
                :disabled="!editable"
                rows="2" maxlength="2000"
                style="text-transform:uppercase"/>
            </div>
            <div class="col-12">
              <label class="form-label" style="font-size:12px">Otros</label>
              <input type="text" class="form-control form-control-sm"
                v-model="formPedido.otros"
                :disabled="!editable"
                maxlength="1000"
                style="text-transform:uppercase"/>
            </div>
          </div>
        </div>
      </div>

      <!-- Catálogo de terapias por categoría -->
      <div class="card mb-3">
        <div class="card-header py-2">
          <small class="fw-bold">Terapias Solicitadas</small>
        </div>
        <div class="card-body py-2">

          <!-- Buscador -->
          <div class="mb-2">
            <input type="text" class="form-control form-control-sm"
              v-model="busquedaTerapia"
              placeholder="Buscar terapia por código o nombre..."
              :disabled="!editable"/>
          </div>

          <!-- Terapias agrupadas por clasificación -->
          <div v-for="(grupo, nombreGrupo) in terapiasFiltradas" :key="nombreGrupo"
            class="mb-3">
            <div class="d-flex align-items-center gap-2 mb-1">
              <span class="badge"
                :style="{ background: colorGrupo(nombreGrupo), fontSize: '10px' }">
                {{ nombreGrupo }}
              </span>
            </div>
            <div class="row g-1">
              <div v-for="terapia in grupo" :key="terapia.idElemEmpr"
                class="col-md-6">
                <div class="terapia-item d-flex align-items-center gap-2 p-2 rounded border"
                  :class="{ 'terapia-seleccionada': estaSeleccionada(terapia.idElemEmpr) }">
                  <input type="checkbox"
                    :checked="estaSeleccionada(terapia.idElemEmpr)"
                    :disabled="!editable"
                    @change="toggleTerapia(terapia)"/>
                  <div class="flex-grow-1">
                    <div style="font-size:11px; color:#888">{{ terapia.codigoElemento }}</div>
                    <div style="font-size:12px; font-weight:500">{{ terapia.nombre }}</div>
                  </div>
                  <!-- Cantidad si está seleccionada -->
                  <div v-if="estaSeleccionada(terapia.idElemEmpr)"
                    class="d-flex align-items-center gap-1">
                    <input type="number"
                      class="form-control form-control-sm"
                      style="width:60px; font-size:12px"
                      :value="getCantidad(terapia.idElemEmpr)"
                      :disabled="!editable"
                      min="1" max="999"
                      @change="setCantidad(terapia.idElemEmpr, $event.target.value)"/>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="Object.keys(terapiasFiltradas).length === 0"
            class="text-center text-muted py-3" style="font-size:13px">
            No se encontraron terapias
          </div>
        </div>
      </div>

      <!-- Resumen seleccionadas -->
      <div class="card mb-3" v-if="formPedido.detalle.length > 0">
        <div class="card-header py-2">
          <small class="fw-bold">
            Resumen — {{ formPedido.detalle.length }} terapia(s) seleccionada(s)
          </small>
        </div>
        <div class="card-body py-2">
          <table class="table table-sm table-bordered" style="font-size:12px">
            <thead class="table-light">
              <tr>
                <th>Código</th>
                <th>Terapia</th>
                <th class="text-center">Cantidad</th>
                <th v-if="editable"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="det in formPedido.detalle" :key="det.idElemEmpr">
                <td>{{ det.codigoElemento }}</td>
                <td>{{ det.nombreElemento }}</td>
                <td class="text-center">{{ det.cantidad }}</td>
                <td v-if="editable" class="text-center">
                  <button type="button" class="btn btn-sm btn-outline-danger p-0 px-1"
                    @click="quitarTerapia(det.idElemEmpr)">
                    <span class="material-symbols-outlined" style="font-size:14px">delete</span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Acciones PTR -->
      <div class="d-flex justify-content-end gap-2 mb-3" v-if="editable">
        <button type="button" class="btn btn-sm btn-success"
          :disabled="guardandoPedido || !formPedido.idMedico || formPedido.detalle.length === 0"
          @click="guardarPedido">
          <span class="material-symbols-outlined" style="font-size:16px">save</span>
          {{ guardandoPedido ? 'Guardando...' : 'Guardar Pedido PTR' }}
        </button>
      </div>

    </div>

    <!--
         TAB RTR — Registro de Sesiones
     -->
    <div v-if="tabActual === 'rtr' && pedido">

      <!-- Resumen del pedido -->
      <div class="card mb-3">
        <div class="card-body py-2">
          <div class="row g-2" style="font-size:12px">
            <div class="col-md-3">
              <span class="text-muted">Médico solicitante:</span>
              <strong class="ms-1">{{ pedido.nombreMedico }}</strong>
            </div>
            <div class="col-md-3">
              <span class="text-muted">Fecha pedido:</span>
              <strong class="ms-1">{{ pedido.fechaPedido }}</strong>
            </div>
            <div class="col-md-3">
              <span class="text-muted">Terapias pedidas:</span>
              <strong class="ms-1">{{ pedido.detalle.length }}</strong>
            </div>
            <div class="col-md-3">
              <span class="text-muted">Sesiones realizadas:</span>
              <strong class="ms-1">{{ sesiones.length }}</strong>
            </div>
          </div>
        </div>
      </div>

      <!-- Formulario nueva sesión -->
      <div class="card mb-3" v-if="editable">
        <div class="card-header py-2">
          <small class="fw-bold">Registrar Nueva Sesión</small>
        </div>
        <div class="card-body py-2">
          <div class="row g-2">
            <div class="col-md-3">
              <label class="form-label" style="font-size:12px">Fecha de Sesión</label>
              <input type="date" class="form-control form-control-sm"
                v-model="formSesion.fechaSesion"/>
            </div>
            <div class="col-md-3">
              <label class="form-label" style="font-size:12px">Área / Tipo de Terapia</label>
              <select class="form-select form-select-sm" v-model="formSesion.area">
                <option value="">-- Seleccione --</option>
                <option v-for="area in areasTerapia" :key="area" :value="area">
                  {{ area }}
                </option>
              </select>
            </div>
            <div class="col-md-3">
              <label class="form-label" style="font-size:12px">Terapeuta</label>
              <select class="form-select form-select-sm" v-model="formSesion.idTerapeuta">
                <option value="">-- Seleccione --</option>
                <option v-for="m in medicos" :key="m.idMedico" :value="m.idMedico">
                  {{ m.nombreMedico }}
                </option>
              </select>
            </div>
            <div class="col-12">
              <label class="form-label" style="font-size:12px">Tratamiento Realizado</label>
              <textarea class="form-control form-control-sm"
                v-model="formSesion.tratamiento"
                rows="2" maxlength="2000"
                style="text-transform:uppercase"
                placeholder="Describa el tratamiento realizado en esta sesión"/>
            </div>
          </div>
          <div class="d-flex justify-content-end mt-2">
            <button type="button" class="btn btn-sm btn-primary"
              :disabled="guardandoSesion || !formSesion.tratamiento || !formSesion.idTerapeuta || !formSesion.fechaSesion"
              @click="agregarSesion">
              <span class="material-symbols-outlined" style="font-size:16px">add</span>
              {{ guardandoSesion ? 'Guardando...' : 'Agregar Sesión' }}
            </button>
          </div>
        </div>
      </div>

      <!-- Listado de sesiones -->
      <div class="card mb-3">
        <div class="card-header py-2">
          <small class="fw-bold">Sesiones Realizadas</small>
        </div>
        <div class="card-body p-0">
          <div v-if="sesiones.length === 0"
            class="text-center text-muted py-4" style="font-size:13px">
            No hay sesiones registradas aún
          </div>
          <table v-else class="table table-sm table-hover mb-0" style="font-size:12px">
            <thead class="table-light">
              <tr>
                <th class="text-center" style="width:50px">Nº</th>
                <th>Fecha</th>
                <th>Área</th>
                <th>Tratamiento</th>
                <th>Terapeuta</th>
                <th class="text-center">Firma</th>
                <th class="text-center">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="sesion in sesiones" :key="sesion.idRehabSesion">
                <td class="text-center fw-bold">{{ sesion.numeroSesion }}</td>
                <td>{{ sesion.fechaSesion }}</td>
                <td>
                  <span class="badge"
                    :style="{ background: colorArea(sesion.area), fontSize:'10px' }">
                    {{ sesion.area || '—' }}
                  </span>
                </td>
                <td style="max-width:200px">
                  <div style="white-space:nowrap; overflow:hidden; text-overflow:ellipsis"
                    :title="sesion.tratamiento">
                    {{ sesion.tratamiento }}
                  </div>
                </td>
                <td>{{ sesion.nombreTerapeuta }}</td>
                <td class="text-center">
                  <span v-if="sesion.tieneFirma"
                    class="badge bg-success" style="font-size:10px">
                    ✓ Firmado
                  </span>
                  <span v-else class="badge bg-warning text-dark" style="font-size:10px">
                    Pendiente
                  </span>
                </td>
                <td class="text-center">
                  <button v-if="!sesion.tieneFirma"
                    type="button" class="btn btn-sm btn-outline-primary p-0 px-2"
                    title="Registrar firma del representante"
                    @click="abrirFirma(sesion)">
                    <span class="material-symbols-outlined" style="font-size:14px">draw</span>
                  </button>
                  <button v-else
                    type="button" class="btn btn-sm btn-outline-secondary p-0 px-2"
                    title="Ver firma"
                    @click="verFirma(sesion)">
                    <span class="material-symbols-outlined" style="font-size:14px">visibility</span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

    </div>

    <!--
         MODAL DE FIRMA
     -->
    <Teleport to="body">
      <div v-if="modalFirma.visible" class="modal-overlay" @click.self="cerrarFirma">
        <div class="modal-firma">

          <!-- Header -->
          <div class="modal-header border-bottom pb-2 mb-3">
            <div>
              <h6 class="mb-0 fw-bold">Firma del Representante</h6>
              <small class="text-muted">
                Sesión Nº {{ modalFirma.sesion?.numeroSesion }} —
                {{ modalFirma.sesion?.fechaSesion }}
              </small>
            </div>
            <button type="button" class="btn-close" @click="cerrarFirma"/>
          </div>

          <!-- Stepper -->
          <div class="stepper mb-3">
            <div v-for="(paso, i) in pasosFirma" :key="i" class="paso"
              :class="{ activo: pasoFirmaActual === i, completado: pasoFirmaActual > i }">
              <div class="paso-circulo">
                <span v-if="pasoFirmaActual > i">✓</span>
                <span v-else>{{ i + 1 }}</span>
              </div>
              <span class="paso-label">{{ paso }}</span>
            </div>
          </div>

          <!-- Paso 0: Datos -->
          <div v-if="pasoFirmaActual === 0">
            <div class="info-box mb-3">
              <p class="mb-0" style="font-size:13px">
                Se registrará la firma del representante para la sesión
                <strong>Nº {{ modalFirma.sesion?.numeroSesion }}</strong>
                del área <strong>{{ modalFirma.sesion?.area }}</strong>.
              </p>
            </div>
            <div class="mb-3">
              <label class="form-label" style="font-size:12px;font-weight:600;text-transform:uppercase">
                Nombre completo del representante
              </label>
              <input type="text" class="form-control form-control-sm"
                v-model="modalFirma.firmadoPor"
                placeholder="Nombre del paciente o representante legal"/>
            </div>
            <div v-if="modalFirma.error" class="alerta-error mb-2">
              {{ modalFirma.error }}
            </div>
          </div>

          <!-- Paso 1: Firma -->
          <div v-if="pasoFirmaActual === 1">
            <SignaturePad
              :ancho="460" :alto="160"
              @update:firma="onFirmaCapturada"/>
            <div v-if="modalFirma.error" class="alerta-error mt-2">
              {{ modalFirma.error }}
            </div>
          </div>

          <!-- Paso 2: Éxito -->
          <div v-if="pasoFirmaActual === 2" class="text-center py-3">
            <div class="exito-icono mx-auto mb-2">✓</div>
            <h6 class="fw-bold">Firma registrada exitosamente</h6>
            <p class="text-muted" style="font-size:13px">
              La sesión Nº {{ modalFirma.sesion?.numeroSesion }} ha sido firmada.
            </p>
          </div>

          <!-- Footer -->
          <div class="d-flex justify-content-end gap-2 mt-3 pt-2 border-top">
            <button v-if="pasoFirmaActual === 0"
              type="button" class="btn btn-sm btn-secondary"
              @click="cerrarFirma">
              Cancelar
            </button>
            <button v-if="pasoFirmaActual === 0"
              type="button" class="btn btn-sm btn-primary"
              :disabled="!modalFirma.firmadoPor"
              @click="pasoFirmaActual = 1">
              Continuar a firma →
            </button>
            <button v-if="pasoFirmaActual === 1"
              type="button" class="btn btn-sm btn-secondary"
              @click="pasoFirmaActual = 0">
              ← Atrás
            </button>
            <button v-if="pasoFirmaActual === 1"
              type="button" class="btn btn-sm btn-success"
              :disabled="!modalFirma.firmaBase64 || modalFirma.cargando"
              @click="registrarFirma">
              {{ modalFirma.cargando ? 'Registrando...' : '✓ Firmar y guardar' }}
            </button>
            <button v-if="pasoFirmaActual === 2"
              type="button" class="btn btn-sm btn-primary"
              @click="cerrarFirma">
              Cerrar
            </button>
          </div>

        </div>
      </div>
    </Teleport>

  </div>
</template>

<script>
import api from '@/services/api'
import swal2 from 'sweetalert2'
import SignaturePad from '@/views/consentimientos/SignaturePad.vue'

const AREAS_TERAPIA = [
  'Terapia Integral',
  'Terapia Física',
  'Electroterapia',
  'Hidroterapia',
  'Terapia de Lenguaje',
  'Terapia Ocupacional',
  'Terapia Neurológica',
  'Terapia Geriátrica',
  'Terapia Respiratoria',
  'Otros'
]

const COLORES_AREA = {
  'Terapia Integral':    '#6366f1',
  'Terapia Física':      '#2980b9',
  'Electroterapia':      '#e67e22',
  'Hidroterapia':        '#1abc9c',
  'Terapia de Lenguaje': '#9b59b6',
  'Terapia Ocupacional': '#27ae60',
  'Terapia Neurológica': '#c0392b',
  'Terapia Geriátrica':  '#f39c12',
  'Terapia Respiratoria':'#16a085',
  'Otros':               '#7f8c8d'
}

export default {
  name: 'RehabilitacionForm',
  components: { SignaturePad },
  props: {
    p_idAtencion:     { type: Number, required: true },
    p_estadoAtencion: { type: String, default: '' },
    p_idMedico:       { type: Number, default: null }
  },
  data() {
    return {
      tabActual: 'ptr',
      areasTerapia: AREAS_TERAPIA,

      // Catálogo
      catalogoTerapias: [],
      busquedaTerapia: '',
      medicos: [],

      // PTR
      pedido: null,
      formPedido: {
        idMedico: '',
        fechaPedido: new Date().toISOString().slice(0, 10),
        horaPedido: new Date().toTimeString().slice(0, 5),
        observaciones: '',
        otros: '',
        detalle: []
      },
      guardandoPedido: false,

      // RTR
      sesiones: [],
      formSesion: {
        idTerapeuta: '',
        fechaSesion: new Date().toISOString().slice(0, 10),
        area: '',
        tratamiento: ''
      },
      guardandoSesion: false,

      // Modal firma
      modalFirma: {
        visible: false,
        sesion: null,
        firmadoPor: '',
        firmaBase64: null,
        cargando: false,
        error: null
      },
      pasosFirma: ['Datos', 'Firma', 'Completado'],
      pasoFirmaActual: 0
    }
  },
  computed: {
    editable() {
      return this.p_estadoAtencion === 'PENDIENTE' ||
             this.p_estadoAtencion === 'PROCESO'
    },
    terapiasFiltradas() {
      const q = this.busquedaTerapia.toLowerCase()
      const resultado = {}
      this.catalogoTerapias.forEach(t => {
        const coincide = !q ||
          t.nombre.toLowerCase().includes(q) ||
          (t.codigoElemento || '').toLowerCase().includes(q)
        if (!coincide) return
        const grupo = t.nombreClasificacion || 'Otros'
        if (!resultado[grupo]) resultado[grupo] = []
        resultado[grupo].push(t)
      })
      return resultado
    }
  },
  mounted() {
    this.cargarCatalogo()
    this.cargarMedicos()
    this.cargarPedido()
    if (this.p_idMedico) this.formPedido.idMedico = this.p_idMedico
  },
  methods: {
    //  Catálogo
    async cargarCatalogo() {
      try {
        const res = await api.get('/vwelememprs')
        // Filtrar solo elementos de categoría rehabilitación
        this.catalogoTerapias = res.data.filter(e =>
          e.estado === 1 &&
          e.nombreClasificacion?.toLowerCase().includes('terapia') ||
          e.codigoElemento?.startsWith('291')
        )
      } catch (e) {
        console.error('Error al cargar catálogo:', e)
      }
    },
    async cargarMedicos() {
      try {
        const res = await api.get('/vwmedicos')
        this.medicos = res.data
      } catch (e) {
        console.error('Error al cargar médicos:', e)
      }
    },

    //  PTR
    async cargarPedido() {
      try {
        const res = await api.get(
          `/rehabilitacion/pedido/atencion/${this.p_idAtencion}`)
        if (res.data) {
          this.pedido = res.data
          this.formPedido = {
            idMedico:      res.data.idMedico,
            fechaPedido:   res.data.fechaPedido,
            horaPedido:    res.data.horaPedido,
            observaciones: res.data.observaciones || '',
            otros:         res.data.otros || '',
            detalle:       res.data.detalle || []
          }
          await this.cargarSesiones()
        }
      } catch (e) {
        if (e.response?.status !== 404 && e.response?.status !== 204) {
          console.error('Error al cargar pedido:', e)
        }
      }
    },
    async guardarPedido() {
      this.guardandoPedido = true
      try {
        const idUsuario = sessionStorage.getItem('idUsuario') || 1
        const payload = {
          idAtencion:    this.p_idAtencion,
          idMedico:      this.formPedido.idMedico,
          fechaPedido:   this.formPedido.fechaPedido,
          horaPedido:    this.formPedido.horaPedido,
          observaciones: this.formPedido.observaciones,
          otros:         this.formPedido.otros,
          detalle:       this.formPedido.detalle.map(d => ({
            idElemEmpr: d.idElemEmpr,
            cantidad:   d.cantidad
          }))
        }
        const res = await api.post(
          `/rehabilitacion/pedido?idUsuario=${idUsuario}`, payload)
        this.pedido = res.data
        swal2.fire({
          title: '¡Éxito!',
          text: 'Pedido PTR guardado correctamente.',
          icon: 'success', confirmButtonText: 'Ok'
        })
      } catch (e) {
        swal2.fire({
          title: 'Error',
          text: 'No se pudo guardar el pedido.',
          icon: 'error', confirmButtonText: 'Ok'
        })
        console.error(e)
      } finally {
        this.guardandoPedido = false
      }
    },

    // Selección de terapias
    estaSeleccionada(idElemEmpr) {
      return this.formPedido.detalle.some(d => d.idElemEmpr === idElemEmpr)
    },
    getCantidad(idElemEmpr) {
      return this.formPedido.detalle.find(
        d => d.idElemEmpr === idElemEmpr)?.cantidad || 1
    },
    setCantidad(idElemEmpr, valor) {
      const det = this.formPedido.detalle.find(d => d.idElemEmpr === idElemEmpr)
      if (det) det.cantidad = parseInt(valor) || 1
    },
    toggleTerapia(terapia) {
      const idx = this.formPedido.detalle
        .findIndex(d => d.idElemEmpr === terapia.idElemEmpr)
      if (idx >= 0) {
        this.formPedido.detalle.splice(idx, 1)
      } else {
        this.formPedido.detalle.push({
          idElemEmpr:     terapia.idElemEmpr,
          codigoElemento: terapia.codigoElemento,
          nombreElemento: terapia.nombre,
          cantidad:       1
        })
      }
    },
    quitarTerapia(idElemEmpr) {
      this.formPedido.detalle =
        this.formPedido.detalle.filter(d => d.idElemEmpr !== idElemEmpr)
    },

    //  RTR
    async cargarSesiones() {
      if (!this.pedido) return
      try {
        const res = await api.get(
          `/rehabilitacion/sesion/pedido/${this.pedido.idRehabPedido}`)
        this.sesiones = res.data
      } catch (e) {
        console.error('Error al cargar sesiones:', e)
      }
    },
    async agregarSesion() {
      this.guardandoSesion = true
      try {
        const idUsuario = sessionStorage.getItem('idUsuario') || 1
        const payload = {
          idRehabPedido: this.pedido.idRehabPedido,
          idTerapeuta:   this.formSesion.idTerapeuta,
          fechaSesion:   this.formSesion.fechaSesion,
          area:          this.formSesion.area,
          tratamiento:   this.formSesion.tratamiento
        }
        const res = await api.post(
          `/rehabilitacion/sesion?idUsuario=${idUsuario}`, payload)
        this.sesiones.push(res.data)
        this.formSesion = {
          idTerapeuta: this.formSesion.idTerapeuta,
          fechaSesion: new Date().toISOString().slice(0, 10),
          area:        '',
          tratamiento: ''
        }
        swal2.fire({
          title: '¡Éxito!',
          text: 'Sesión registrada correctamente.',
          icon: 'success', confirmButtonText: 'Ok',
          timer: 1500, showConfirmButton: false
        })
      } catch (e) {
        swal2.fire({
          title: 'Error',
          text: 'No se pudo registrar la sesión.',
          icon: 'error', confirmButtonText: 'Ok'
        })
      } finally {
        this.guardandoSesion = false
      }
    },

    //  Firma
    abrirFirma(sesion) {
      this.modalFirma = {
        visible: true, sesion,
        firmadoPor: '', firmaBase64: null,
        cargando: false, error: null
      }
      this.pasoFirmaActual = 0
    },
    cerrarFirma() {
      this.modalFirma.visible = false
      this.pasoFirmaActual = 0
    },
    verFirma(sesion) {
      swal2.fire({
        title: `Sesión Nº ${sesion.numeroSesion}`,
        html: `<p>Firmado por: <strong>${sesion.firmadoPor}</strong></p>
               <p>Fecha: ${sesion.fechaFirma}</p>`,
        icon: 'info', confirmButtonText: 'Cerrar'
      })
    },
    onFirmaCapturada(base64) {
      this.modalFirma.firmaBase64 = base64
    },
    async registrarFirma() {
      this.modalFirma.cargando = true
      this.modalFirma.error = null
      try {
        const payload = {
          firmaBase64: this.modalFirma.firmaBase64,
          firmadoPor:  this.modalFirma.firmadoPor,
          direccionIp: await this.obtenerIp(),
          userAgent:   navigator.userAgent
        }
        await api.post(
          `/rehabilitacion/sesion/${this.modalFirma.sesion.idRehabSesion}/firmar`,
          payload)
        // Actualizar sesión en lista
        const idx = this.sesiones.findIndex(
          s => s.idRehabSesion === this.modalFirma.sesion.idRehabSesion)
        if (idx >= 0) {
          this.sesiones[idx].tieneFirma  = true
          this.sesiones[idx].firmadoPor  = this.modalFirma.firmadoPor
          this.sesiones[idx].fechaFirma  = new Date().toLocaleDateString()
        }
        this.pasoFirmaActual = 2
      } catch (e) {
        this.modalFirma.error = 'Error al registrar la firma. Intente nuevamente.'
      } finally {
        this.modalFirma.cargando = false
      }
    },
    async obtenerIp() {
      try {
        const res = await fetch('https://api.ipify.org?format=json')
        const data = await res.json()
        return data.ip
      } catch { return 'desconocida' }
    },

    //  Helpers visuales
    colorGrupo(nombre) {
      return COLORES_AREA[nombre] || '#6c757d'
    },
    colorArea(area) {
      return COLORES_AREA[area] || '#6c757d'
    }
  }
}
</script>

<style scoped>
/* Tabs */
.tab-modo {
  border: none;
  background: transparent;
  padding: 6px 16px;
  font-size: 13px;
  font-weight: 500;
  border-bottom: 3px solid transparent;
  border-radius: 0;
  cursor: pointer;
  transition: all 0.2s;
  display: inline-flex;
  align-items: center;
  gap: 5px;
}
.tab-modo:disabled { opacity: 0.45; cursor: not-allowed; }
.tab-modo-active-edit {
  border-bottom: 3px solid #f39c12;
  color: #f39c12;
}
.tab-modo-active-view {
  border-bottom: 3px solid #17a2b8;
  color: #17a2b8;
}
.tab-modo-inactive { color: #6c757d; }
.tab-modo-inactive:hover:not(:disabled) {
  color: #343a40;
  border-bottom: 3px solid #dee2e6;
}
/* Terapias */
.terapia-item {
  background: #f9fafb;
  cursor: pointer;
  transition: all 0.15s;
  font-size: 12px;
}
.terapia-item:hover { background: #eef2ff; border-color: #6366f1 !important; }
.terapia-seleccionada {
  background: #eef2ff !important;
  border-color: #6366f1 !important;
}
/* Modal firma */
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  padding: 16px;
}
.modal-firma {
  background: #fff;
  border-radius: 12px;
  width: 100%;
  max-width: 520px;
  padding: 24px;
  box-shadow: 0 20px 60px rgba(0,0,0,0.2);
}
/* Stepper */
.stepper { display: flex; gap: 0; }
.paso {
  display: flex; align-items: center;
  gap: 8px; flex: 1; position: relative;
}
.paso:not(:last-child)::after {
  content: ''; position: absolute;
  left: 28px; right: 0; top: 14px;
  height: 2px; background: #e5e7eb; z-index: 0;
}
.paso.completado:not(:last-child)::after { background: #6366f1; }
.paso-circulo {
  width: 28px; height: 28px; border-radius: 50%;
  border: 2px solid #e5e7eb;
  display: flex; align-items: center; justify-content: center;
  font-size: 12px; font-weight: 700;
  color: #9ca3af; background: #fff; z-index: 1;
  flex-shrink: 0; transition: all 0.2s;
}
.paso.activo  .paso-circulo { border-color:#6366f1; color:#6366f1; background:#eef2ff; }
.paso.completado .paso-circulo { border-color:#6366f1; background:#6366f1; color:#fff; }
.paso-label { font-size: 12px; color: #9ca3af; font-weight: 500; }
.paso.activo    .paso-label { color: #6366f1; font-weight: 600; }
.paso.completado .paso-label { color: #6366f1; }
/* Info / error */
.info-box {
  background: #eef2ff; border: 1px solid #c7d2fe;
  border-radius: 8px; padding: 12px 14px;
}
.alerta-error {
  background: #fef2f2; border: 1px solid #fecaca;
  border-radius: 8px; padding: 10px 14px;
  font-size: 13px; color: #dc2626;
}
.exito-icono {
  width: 56px; height: 56px; border-radius: 50%;
  background: #d1fae5; color: #059669;
  font-size: 24px; display: flex;
  align-items: center; justify-content: center;
}
</style>